import "./Application.module.css";
import KennelEliteHeader from "@/reusable_sections/Header";
import MustRead from "./sections/MustRead";
import ListYourHome from "./sections/ListYourHome";
import PuppyAvailability from "./sections/PuppyAvailability";
import AtlasRootsFooter from "@/reusable_sections/Footer";
export default function ApplicationPage() {
  return <div>
      <KennelEliteHeader />
      <MustRead />
      <PuppyAvailability />
      <ListYourHome />
      <AtlasRootsFooter />
    </div>;
}